const TOUR_STORAGE_PREFIX = "aq_faq_page_tour_v1";

export function getFaqPageTourStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedFaqPageTour(staffId) {
  try {
    return localStorage.getItem(getFaqPageTourStorageKey(staffId)) === "1";
  } catch {
    return false;
  }
}

export function markFaqPageTourCompleted(staffId) {
  try {
    localStorage.setItem(getFaqPageTourStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}
